export const setDate = (date) => (
    (dispatch) => {
        dispatch({ type: 'SET_DATE', date: date });
    }
);